var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#E87040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912:2175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3083 13.6205H20.2131C20.1083 13.6205 20.0226 13.7062 20.0226 13.811V14.9538C20.0226 15.0586 20.1083 15.1443 20.2131 15.1443H26.3083C26.4131 15.1443 26.4988 15.0586 26.4988 14.9538V13.811C26.4988 13.7062 26.4131 13.6205 26.3083 13.6205ZM23.1179 16.8586H20.2131C20.1083 16.8586 20.0226 16.9443 20.0226 17.0491V18.1919C20.0226 18.2967 20.1083 18.3824 20.2131 18.3824H23.1179C23.2226 18.3824 23.3083 18.2967 23.3083 18.1919V17.0491C23.3083 16.9443 23.2226 16.8586 23.1179 16.8586ZM15.1726 11.4896H14.1417C13.994 11.4896 13.875 11.6086 13.875 11.7562V17.661C13.875 17.7467 13.9155 17.8253 13.9845 17.8753L17.5298 20.461C17.6488 20.5467 17.8155 20.5229 17.9012 20.4039L18.5131 19.5681V19.5658C18.5988 19.4467 18.5726 19.28 18.4536 19.1943L15.4369 17.0134V11.7562C15.4393 11.6086 15.3179 11.4896 15.1726 11.4896Z",
    fill: "#E87040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9711 19.8503H21.5949C21.4616 19.8503 21.3354 19.9193 21.2639 20.0336C20.9611 20.5136 20.6057 20.9584 20.2044 21.3598C19.5134 22.053 18.6943 22.6053 17.7925 22.986C16.8568 23.3812 15.8639 23.5812 14.8401 23.5812C13.8139 23.5812 12.8211 23.3812 11.8877 22.986C10.9854 22.605 10.1735 22.0574 9.47584 21.3598C8.77822 20.6622 8.2306 19.8503 7.84964 18.9479C7.45441 18.0145 7.25441 17.0217 7.25441 15.9955C7.25441 14.9693 7.45441 13.9788 7.84964 13.0431C8.2306 12.1407 8.77822 11.3288 9.47584 10.6312C10.1735 9.93359 10.9854 9.38597 11.8877 9.00502C12.8211 8.60978 13.8163 8.40978 14.8401 8.40978C15.8663 8.40978 16.8592 8.60978 17.7925 9.00502C18.6949 9.38597 19.5068 9.93359 20.2044 10.6312C20.6057 11.0326 20.9611 11.4774 21.2639 11.9574C21.3354 12.0717 21.4616 12.1407 21.5949 12.1407H22.9711C23.1354 12.1407 23.2401 11.9693 23.1663 11.8241C21.6139 8.73597 18.4663 6.72882 14.952 6.68835C9.80679 6.62406 5.53298 10.836 5.52345 15.9764C5.51393 21.1264 9.68774 25.305 14.8377 25.305C18.3973 25.305 21.5973 23.2907 23.1663 20.1669C23.183 20.1336 23.191 20.0966 23.1894 20.0593C23.1877 20.0221 23.1766 19.9859 23.157 19.9541C23.1375 19.9224 23.1101 19.8962 23.0776 19.878C23.045 19.8598 23.0084 19.8503 22.9711 19.8503Z",
    fill: "#E87040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912:2175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "none",
    transform: "translate(5.33301 5.33334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.ccbbabe87feb891ed90caa2f682e62da.svg";
export { ForwardRef as ReactComponent };